import {
  CalendarEvent,
  CalendarEventEditScope,
  CalendarRecurringMutationScope,
  CalendarSingleOccurrenceMutationTarget,
} from '@cue/calendars';

export type RecurringMutationEvent = Pick<CalendarEvent, 'occurrenceId' | 'seriesMasterId'> & {
  id?: string;
  type?: CalendarEvent['type'];
};

export type SingleOccurrenceTargetResolver = (event: CalendarSingleOccurrenceMutationTarget) => string;

export function isOccurrenceLikeEvent(event: Pick<RecurringMutationEvent, 'type'> | null | undefined): boolean {
  return event?.type === 'occurrence' || event?.type === 'exception';
}

export function resolveRecurringMutationScope(
  event: RecurringMutationEvent,
  selectedEditScope: CalendarEventEditScope
): CalendarRecurringMutationScope {
  if (selectedEditScope === 'singleOccurrence' && isOccurrenceLikeEvent(event) && event.occurrenceId) {
    return {
      scope: 'single',
      occurrenceId: event.occurrenceId,
    };
  }

  return { scope: 'all' };
}

export function resolveRecurringMutationTargetEventId(
  event: RecurringMutationEvent,
  selectedEditScope: CalendarEventEditScope,
  resolveSingleOccurrenceTarget: SingleOccurrenceTargetResolver
): string {
  if (selectedEditScope === 'singleOccurrence' && isOccurrenceLikeEvent(event)) {
    return resolveSingleOccurrenceTarget(toSingleOccurrenceMutationTarget(event));
  }

  if (selectedEditScope === 'seriesMaster' && isOccurrenceLikeEvent(event) && event.seriesMasterId) {
    return event.seriesMasterId;
  }

  return event.id ?? '';
}

export function resolveSingleOccurrenceMutation(
  event: RecurringMutationEvent,
  resolveSingleOccurrenceTarget: SingleOccurrenceTargetResolver
): { mutationScope: CalendarRecurringMutationScope; targetEventId: string } | null {
  if (!event.occurrenceId) {
    return null;
  }

  return {
    mutationScope: {
      scope: 'single',
      occurrenceId: event.occurrenceId,
    },
    targetEventId: resolveSingleOccurrenceTarget(toSingleOccurrenceMutationTarget(event)),
  };
}

function toSingleOccurrenceMutationTarget(event: RecurringMutationEvent): CalendarSingleOccurrenceMutationTarget {
  return {
    id: event.id ?? '',
    seriesMasterId: event.seriesMasterId,
    type: event.type ?? 'singleInstance',
  };
}
